import { render, staticRenderFns } from "./FreeTypeYearQuestion.vue?vue&type=template&id=88dd1fd8&"
import script from "./FreeTypeYearQuestion.vue?vue&type=script&lang=js&"
export * from "./FreeTypeYearQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports